import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';

/**
 * The styled component for the GradientOverlay
 *
 * @param {GradientOverlayProps} props - The props for the GradientOverlay component.
 * @returns {JSX.Element} The GradientOverlay component.
 */
var GradientOverlay = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    background = _a.background;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 48px;\n    /* stylelint-disable */\n    background-image: linear-gradient(\n      to right,\n      rgba(255, 255, 255, 0),\n      ", "\n        80%\n    );\n    /* stylelint-enable */\n    z-index: 1;\n    pointer-events: none;\n  "], ["\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 48px;\n    /* stylelint-disable */\n    background-image: linear-gradient(\n      to right,\n      rgba(255, 255, 255, 0),\n      ", "\n        80%\n    );\n    /* stylelint-enable */\n    z-index: 1;\n    pointer-events: none;\n  "])), background !== 'sand' ? theme.designTokens.colors.grey0 : theme.designTokens.colors.secondary10);
});
var templateObject_1, templateObject_2;

export { GradientOverlay };
//# sourceMappingURL=GradientOverlay.js.map
